import { Base } from "ui/Scripts/source/framework/base";
import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { EventChartOptions, IEventChartOptions } from "./eventChartOptions";
import { IdTitleNode, IIdTitleNode } from "ui/Scripts/source/models/common/idTitleNode";

export interface IEventChartPropertiesDialogData {
    eventTypes: IIdTitleNode[];
    groupingTypes: IIdTitle[];
    timeSpans: IIdTitle[];
    chartOptions: IEventChartOptions;
}

export class EventChartPropertiesDialogData implements IEventChartPropertiesDialogData {
    eventTypes: IdTitleNode[];
    groupingTypes: IdTitle[];
    timeSpans: IdTitle[];
    chartOptions: EventChartOptions;

    constructor();
    constructor(obj: IEventChartPropertiesDialogData);
    constructor(obj?: any) {
        this.chartOptions = new EventChartOptions(obj ? obj.chartOptions : null);
        this.eventTypes = Base.getTypedArray(obj ? obj.eventTypes : null, IdTitleNode);
        this.groupingTypes = Base.getTypedArray(obj ? obj.groupingTypes : null, IdTitle);
        this.timeSpans = Base.getTypedArray(obj ? obj.timeSpans : null, IdTitle);
    }
}